module.exports = __webpack_public_path__ + "c_static/img/3-4电脑京东购物车.beb3819.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/3-4电脑京东购物车.jpg
// module id = yyXh
// module chunks = 33